import { createAction } from 'redux-actions'
import { createApiActions } from '@tabeeb/shared/utils/actions'

export const getPointCloudGeoSearch = createApiActions('GET_POINT_CLOUD_GEOSEARCH')

export const setPointCloudGeoSearchOpen = createAction('SET_POINT_CLOUD_GEO_SEARCH_OPEN')
